var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 48 53.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-music-5354268",
    d: "M193.83,60.617c0-3.408-1.166-5.941-3.511-7.237a9.509,9.509,0,0,0-6.923-.444l-14.96,3.852a7.764,7.764,0,0,0-6.148,7.681v23A10.286,10.286,0,1,0,166.4,95.7V73.99l23.315-5.829V81.983a10.285,10.285,0,1,0,4.016,9.651,2.057,2.057,0,0,0,.1-.628Zm-4.114,3.3v-3.3c0-2.484-.788-3.305-1.386-3.636a5.569,5.569,0,0,0-3.907-.061l-14.962,3.853a3.664,3.664,0,0,0-3.059,3.7v5.28Zm-33.6,25.606a6.171,6.171,0,1,1-6.171,6.171A6.171,6.171,0,0,1,156.116,89.526Zm33.6.686a6.171,6.171,0,1,0-6.171,6.171A6.172,6.172,0,0,0,189.716,90.212Z",
    transform: "translate(-145.83 -52.498)",
    fillRule: "evenodd",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicIcon);
export default __webpack_public_path__ + "static/media/music-icon.2af37ac97f2f5a11bc6eb7e9c090024e.svg";
export { ForwardRef as ReactComponent };